import { j as l } from "../../../jsx-runtime-82a9ddf6.js";
const r = ({ width: e = 20, height: s = 20, className: t, style: o }) => /* @__PURE__ */ l.jsx("svg", { width: e, height: s, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: t, style: o, children: /* @__PURE__ */ l.jsx(
  "path",
  {
    className: "dark:fill-slate-700 fill-slate-200",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 13.1463L4.09222 15.2008C3.62452 15.4466 3.04604 15.2668 2.80016 14.7991C2.70225 14.6129 2.66846 14.3996 2.70403 14.1922L3.45034 9.84086L0.288927 6.75925C-0.0894508 6.39042 -0.0971931 5.78469 0.271634 5.40632C0.418503 5.25564 0.610945 5.15759 0.819168 5.12733L5.18813 4.49249L7.14199 0.533537C7.37584 0.0597044 7.94953 -0.134839 8.42336 0.0990108C8.61204 0.192131 8.76477 0.344854 8.85789 0.533537L10.8117 4.49249L15.1807 5.12733C15.7036 5.20332 16.0659 5.68881 15.9899 6.21172C15.9597 6.41994 15.8616 6.61238 15.7109 6.75925L12.5495 9.84086L13.2958 14.1922C13.3852 14.713 13.0354 15.2076 12.5146 15.2969C12.3072 15.3324 12.0939 15.2987 11.9077 15.2008L7.99994 13.1463Z"
  }
) });
export {
  r as EmptyStarIcon
};
